<template>
  <div class="lexiangWrap">
    <dt :class="['searches-logo']">
      <img v-lazy="item.imgUrl" :alt="item.name" />
    </dt>
    <dd class="searches-title">
      <p
        class="searches-title__name"
        v-if="item.highlight"
        v-html="item.highlight"
      ></p>
      <p class="searches-title__name" v-else>{{ item.name }}</p>
      <div class="lex-desc">
        <div class="lex-desc-item">
          <p class="searches-title__addressInfo" v-if="item.address">
            <span class="address-desc" v-if="item.address">{{item.address}}</span>
          </p>
          <p class="searches-title__tags clearfix" v-if="item.tage && item.tage.length > 0">
            <span
                v-for="(record, index) in item.tage"
                :key="index"
            >{{ record }}</span>
          </p>
        </div>
        <div class="lex-desc-text">
            {{ item.distance }}
          <div style="text-align: right;" v-if="!item.isPositioningCity ">{{ item.cityName }}</div>
        </div>
      </div>
    
      <div class="searches-title__priceInfo">
        <div>
          <span class="searches-title__priceInfo__price" v-if="item.sellingPrice > 0">
            <img :src="unionIcon" />
            {{parseFloat(getUnionPrice(item.sellingPrice))}}
            <span v-if="item.showQi" class="searches-title-start">{{TLang('起', 'result')}}</span>
          </span>
        </div>
        <div>
          <span class="searches-title__priceInfo__disablePrice" v-if="item.marketPrice > 0">
            <img :src="unionIcon" />
            <span class="disable-decoration">{{parseFloat(getUnionPrice(item.marketPrice))}}</span>
          </span>
        </div>
      </div>
    </dd>
  </div>
</template>

<script>
import fudou from "../assets/imgs/fudou.png";
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      unionIcon: window.union_icon || fudou,
    };
  },
  methods: {
    getUnionPrice(price) {
      if(price === 0) {
        return "0.00";
      }
      if(!price) {
        return price;
      }
      return (price * this.getUnionScale()).toFixed(2);
    },
    getUnionScale() {
      return window.union_scale || 1;
    }
  }
};
</script>

<style lang="less" scope>
@375: 320/375;
.lexiangWrap {
  display: block;
  width: 100%;
  min-height: 80px * @375;
  height: auto;
}
.lex-desc {
  display: flex;

  .lex-desc-item {
    flex: 1;
  }
  .lex-desc-text {
    height: 16px;
    font-size: 12px*@375;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    margin-left: 10px;
  }
  .lex-desc-distance {
  }
}
.searches {
  &-logo {
    float: left;
    margin-right: 10px * @375;
    text-align: center;
    width: 90px * @375;
    height: 90px * @375;
    border-radius: 4px * @375;
    overflow: hidden;
    > img {
      vertical-align: top;
      max-width: 100%;
      max-height: 100%;
    }
    &__fill {
      position: relative;
      &:after {
        content: "补货中";
        position: absolute;
        top: 15px;
        right: 15px;
        bottom: 15px;
        left: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        font-size: 12px;
        border-radius: 50%;
      }
    }
  }
  &-title {
    min-height: 40px * @375;
    overflow: hidden;
    position: relative;
    &__name {
      max-height: 40px * @375;
      overflow: hidden;
      font-size: 14px * @375;

      font-weight: 400;
      color: #333333;
      line-height: 20px * @375;
      margin-bottom: 5px * @375;
      word-break: break-all;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;

      .ellipsis();
      white-space: normal;
    }
    &__tags{
      margin-bottom: 5px * @375;
      height: 18px * @375;
      padding: 0;
      overflow: hidden;
      width: 100%;
      // display: flex;
      // flex-wrap: wrap;
      span {
        display: block;
        background: rgba(36,125,255,0.05);
        height: 16px * @375;
        border-radius: 2px * @375;
        box-sizing: border-box;
        padding: 0 2px * @375;
        font-size: 12px * @375;
        font-weight: 400;
        color: #247DFF;
        line-height: 16px * @375;
        margin-right: 5px * @375;
        margin-bottom: 5px * @375;
        float: left;
      }
    }
    &__addressInfo {
      padding: 0;
      width: 100%;
      font-size: 12px * @375;
      font-weight: 400;
      color: #666666;
      line-height: 18px * @375;
      word-break: break-all;
      margin-bottom: 5px * @375;
      display: flex;
      justify-content: space-between;
      .address-desc{
        display: inline-block;
        white-space: normal;
        word-break: break-all;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .distance {
        flex-shrink: 0;
        white-space: nowrap;
        margin-left: 16px;
      }
    }
    &__priceInfo {
      width: 100%;
      &__price {
        display: flex;
        align-items: center;
        font-size: 18px * @375;
        font-weight: 600;
        color: #FF5757;
        line-height: 24px * @375;
        img {
          width: 12px * @375;
          height: 12px * @375;
        }
        .searches-title-start {
          font-size: 12px * @375;
          font-weight: 400;
          color: #666;
          margin-left: 2px * @375;
          position: relative;
          top: 2px;
        }
      }
      &__disablePrice {
        display: flex;
        align-items: center;

        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: #ccc;
        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
        img {
          width: 12px * @375;
          height: 12px * @375;
        }
        .disable-decoration {
          text-decoration: line-through;
          font-size: 12px * @375;
          font-weight: 400;
          color: #999999;
          line-height: 16px * @375;
        }
      }
    }
  }
}
.clearfix {
  zoom: 1;
}
.clearfix:after {
  content: " ";
  display: block;
  height: 0;
  font-size: 0;
  clear: both;
  visibility: hidden;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
</style>
